import posthog from 'posthog-js';

import { config } from '~/config';

const isDevOrLocalEnvironment = () =>
  config.app.isLocalEnvironment ||
  ['dev', 'local'].includes(config.app.environment);

const shouldEnableTracking = () =>
  ['staging', 'prod'].includes(config.app.environment);

const getErrorMessage = (exception: unknown) => {
  if (typeof exception === 'string') {
    return exception;
  }

  try {
    return JSON.stringify(exception);
  } catch {
    return String(exception);
  }
};

const toError = (exception: Error | unknown) =>
  exception instanceof Error
    ? exception
    : new Error(getErrorMessage(exception));

const captureException = (
  exception: Error | unknown,
  context?: Record<string, string>
) => {
  const errorToLog = toError(exception);

  if (isDevOrLocalEnvironment()) {
    console.error('[Tracking]', errorToLog, context);
    return;
  }

  // eslint-disable-next-line no-console
  console.error({
    Logger: errorToLog.message || 'Unknown Error',
    stack: errorToLog.stack,
    context,
  });

  if (shouldEnableTracking()) {
    posthog.captureException(errorToLog, context);
  }
};

const captureMessage = (message: string, level?: string) => {
  if (isDevOrLocalEnvironment()) {
    console.error('[Tracking]', message, level);
    return;
  }

  // eslint-disable-next-line no-console
  console.error({ Logger: message, level });

  if (shouldEnableTracking()) {
    posthog.captureException(new Error(message), {
      $exception_level: level ?? 'error',
    });
  }
};

export const Tracking = {
  captureException,
  captureMessage,
};
